import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppDefaultComponent } from './app-default.component';
import { UnauthorizedComponent } from 'projects/insight/src/app/routes/frontend/unauthorized.component';
import { PemGuardService } from './routes/frontend/pem/pem-guard.service';
import { NotFoundComponent } from './routes/frontend/not-found.component';
import { BackendGuardService } from './routes/backend/backend-guard.service';
import { CustomerCareGuardService } from './routes/frontend/customer-care/customer-care-guard.service';
import { SalesSummaryGuardService } from './routes/frontend/sales-summary/sales-summary-guard.service';
import { SalesAndMarketingGuardService } from './routes/frontend/sales-and-marketing/sales-and-marketing-guard.service';
import { DashboardGuardService } from './routes/frontend/dashboard/dashboard-guard.service';
import { FrontendGuardService } from './routes/frontend/frontend-guard.service';
import { GisFileGuardService } from './routes/frontend/gis-file/gis-file-guard.service';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./routes/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'backend',
    loadChildren: () => import('./routes/backend/backend.module').then(m => m.BackendModule),
    canActivate: [BackendGuardService],
    canLoad: [BackendGuardService]
  },
  {
    path: 'bpm',
    loadChildren: () => import('./routes/frontend/bpm/bpm.module').then(m => m.BpmModule)
  },
  {
    path: 'work-order',
    loadChildren: () => import('./routes/frontend/work-order/work-order.module').then(m => m.WorkOrderModule)
  },
  {
    path: 'customer-care',
    loadChildren: () => import('./routes/frontend/customer-care/customer-care.module').then(m => m.CustomerCareModule),
    canLoad: [CustomerCareGuardService],
    canActivate: [CustomerCareGuardService]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./routes/frontend/dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [DashboardGuardService],
    canActivate: [DashboardGuardService]
  },
  {
    path: 'digital-file',
    loadChildren: () => import('./routes/frontend/digital-file/digital-file.module').then(m => m.DigitalFileModule),
    canActivate: [BackendGuardService],
    canLoad: [BackendGuardService]
  },
  {
    path: 'gis',
    loadChildren: () => import('./routes/frontend/gis-file/gis-file.module').then(m => m.GisFileModule),
    canActivate: [GisFileGuardService],
    canLoad: [GisFileGuardService]
  },
  {
    path: 'ebook',
    loadChildren: () => import('./routes/frontend/ebook/ebook.module').then(m => m.EbookModule)
  },
  {
    path: 'event',
    loadChildren: () => import('./routes/frontend/event/event.module').then(m => m.EventModule)
  },
  {
    path: 'hc',
    loadChildren: () => import('./routes/frontend/hc/hc.module').then(m => m.HcModule)
  },
  {
    path: 'kpp',
    loadChildren: () => import('./routes/frontend/kpp/kpp.module').then(m => m.KppModule)
  },
  {
    path: 'launching-maggiore-square-grande',
    loadChildren: () => import('./routes/frontend/launching-maggiore/launching-maggiore.module').then(m => m.LaunchingMaggioreModule)
  },
  {
    path: 'marketing-event',
    loadChildren: () => import('./routes/frontend/marketing-event/marketing-event.module').then(m => m.MarketingEventModule)
  },
  {
    path: 'pdf',
    loadChildren: () => import('./routes/pdf/pdf.module').then(m => m.PdfModule)
  },
  {
    path: 'pem',
    loadChildren: () => import('./routes/frontend/pem/pem.module').then(m => m.PemModule),
    canLoad: [PemGuardService],
    canActivate: [PemGuardService]
  },
  {
    path: 'salesmenu',
    redirectTo: 'siteplan'
  },
  {
    path: 'sales-summary',
    loadChildren: () => import('./routes/frontend/sales-summary/sales-summary.module').then(m => m.SalesSummaryModule),
    canLoad: [SalesSummaryGuardService]
  },
  {
    path: 'sales-and-marketing',
    loadChildren: () => import('./routes/frontend/sales-and-marketing/sales-and-marketing.module').then(m => m.SalesAndMarketingModule),
    canLoad: [SalesAndMarketingGuardService],
    canActivate: [SalesAndMarketingGuardService]
  },
  {
    path: 'siteplan',
    loadChildren: () => import('./routes/frontend/siteplan/siteplan.module').then(m => m.SiteplanModule),
    canActivate: [FrontendGuardService],
    canLoad: [FrontendGuardService]
  },
  {
    path: '',
    component: AppDefaultComponent,
    pathMatch: 'full',
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'unauthorized-access',
    component: UnauthorizedComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
